import { LoadingStatus } from "../../enums/loadingStatus";
import Button, { ButtonTypes } from "../button/button";
import PopupLayout from "../layouts/popupLayout/popupLayout";
import "./confirmationPopup.scss";

export default function ConfirmationPopup(props: {
  description?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  loadingStatus?: LoadingStatus | undefined;
}) {
  return (
    <PopupLayout maxWidth="400px" onClickClose={props.onCancel}>
      <div className="confirmation-popup">
        <h4 style={{ margin: "0" }}>{props.description}</h4>
        <div className="confirmation-buttons-container">
          <Button
            type={ButtonTypes.OUTLINED}
            text={"Cancel"}
            onClick={props.onCancel}
          />
          <Button
            loadingStatus={props.loadingStatus}
            type={ButtonTypes.PRIMARY}
            text={"Confirm"}
            onClick={props.onConfirm}
          />
        </div>
      </div>
    </PopupLayout>
  );
}
